export class ChangePassWord {
  public constructor(
    public ID: boolean,
    public userType: number,
    public newPassword: string
  ) { }
}
